import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createInvitation, deleteInvitation } from "./requests";
import type { Invitation } from "../types";

export const useCreateInvitation = (onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Invitation) => createInvitation(data),
    onSuccess: (data, variables) => {
      if (variables.context === 'organisation' && variables.organisationId) {
        queryClient.invalidateQueries({ queryKey: ['organisation-invitations', variables.organisationId] });
      } else if (variables.context === 'workspace' && variables.workspaceId) {
        queryClient.invalidateQueries({ queryKey: ['workspace-invitations', variables.workspaceId] });
      }
      onSuccess?.(data);
    },
    onError,
  });
};

export const useDeleteInvitation = (onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables: { id: string, context: 'organisation' | 'workspace' }) => deleteInvitation(variables.id),
    onSuccess: (data, variables) => {
      if (variables.context === 'organisation') {
        queryClient.invalidateQueries({ queryKey: ['organisation-invitations'] });
      } else if (variables.context === 'workspace') {
        queryClient.invalidateQueries({ queryKey: ['workspace-invitations'] });
      }
      onSuccess?.(data);
    },
    onError,
  });
};